import { useState } from "react";
import { useDispatch } from "react-redux";
import { setFilter } from "../redux/features/filter/filterSlice";


export default function Filter() {
    const [isFeatured, setFeatured] = useState(false);

    const featuredHandler = ()=>{
        dispatch(setFilter(true))
        setFeatured(true)
    }

    const allHandler = ()=>{
        dispatch(setFilter(false))
        setFeatured(false)
    }
    const dispatch = useDispatch()
    return (
        <div className="flex items-center justify-between mb-12">
            <h4 className="mt-2 text-xl font-bold">Book List</h4>

            <div className="flex items-center space-x-4">
                <button onClick={allHandler} className={`lws-filter-btn ${!isFeatured && "active-filter"}`}>All</button>
                <button onClick={featuredHandler} className={`lws-filter-btn ${isFeatured && "active-filter"}`}>Featured</button>
            </div>
        </div>
    )
};